export default __webpack_public_path__ + "4a03a426aeb0c34309cf31e9a6e96091.png";